// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__8pkrs","col":"Detail_col__Bzxld"};